<template>
	<div class="container tac">
		<div class="m_sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="headline_m">
						{{ $t('rtr_business-how-start.title1') }}
					</p>
					<p class="body_m">
						{{ $t('rtr_business-how-start.text1') }}<br />
						{{ $t('rtr_business-how-start.text2') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button class="button_bg_black" @click="notYet">
							{{ $t('button.down') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="m_sub_middle body_l">
				<p>{{ $t('rtr_business-how-start.text3') }}</p>
				<button class="button_bg_red" @click="$router.push({ name: 'cs' })">
					{{ $t('button.start') }}
				</button>
			</div>
			<div class="m_sub_bottom">
				<h2 class="headline_m mb_20">
					{{ $t('rtr_business-how-start.title2') }}
				</h2>
				<p class="sub_text body_m mb_5">
					{{ $t('rtr_business-how-start.text4') }}
					{{ $t('rtr_business-how-start.text5') }}
				</p>
				<a href="mailto:help@janopay.com" class="m_link_type_02"
					>help@janopay.com<span class="CIRCLE_ARROW"></span
				></a>
			</div>
		</section>
		<section class="content_area type_2">
			<swiper
				:centered-slides="true"
				:slides-per-view="1.3"
				:space-between="16"
				class="rectangle_area"
			>
				<swiper-slide class="rectangle">
					<div class="rectangle1">
						<h2 class="title_m mb_20 mt_30">
							{{ $t('rtr_business-how-start.title3') }}
						</h2>
						<p class="body_m mb_15">
							{{ $t('rtr_business-how-start.text7') }} <br />
							{{ $t('rtr_business-how-start.text8') }}
						</p>
						<router-link :to="{ name: 'auth-register' }" class="m_link_type_02"
							>{{ $t('rtr_business-how-start.text9') }}
						</router-link>
					</div>
				</swiper-slide>
				<swiper-slide class="rectangle"
					><div class="rectangle2">
						<h2 class="title_m mb_20 mt_30">
							{{ $t('rtr_business-how-start.title4') }}
						</h2>
						<p class="body_m mb_15">
							{{ $t('rtr_business-how-start.text10') }}<br />
							{{ $t('rtr_business-how-start.text11') }}<br />
							{{ $t('rtr_business-how-start.text12') }}
						</p>
					</div>
				</swiper-slide>
			</swiper>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
import { Pagination, Navigation } from 'swiper';
export default {
	name: 'Start.m',
	setup() {
		return {
			modules: [Pagination, Navigation],
		};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
<style scoped></style>
